import { render, staticRenderFns } from "./TelephoneInformation.vue?vue&type=template&id=c800413e&scoped=true"
import script from "./TelephoneInformation.vue?vue&type=script&lang=js"
export * from "./TelephoneInformation.vue?vue&type=script&lang=js"
import style0 from "./TelephoneInformation.vue?vue&type=style&index=0&id=c800413e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c800413e",
  null
  
)

export default component.exports